import React, { useEffect, useState } from "react";
import TopBanner from "../components/TopBanner";
import { Outlet, useRouteLoaderData, useLocation, Navigate } from "react-router-dom";
import { topMenu } from "../Constants";
import { getSystemStatus } from "../API";

function Root() {
  const auth = useRouteLoaderData("markit");
  const location = useLocation();
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    getSystemStatus().then((s) => setReadOnly(s.readonly === true));
  }, []);

  const ROLE_SECTIONS = {
    ADMIN:          ["dashboard", "reports", "admin", "features", "performance", "logout"],
    MANAGEMENT:     ["dashboard", "reports", "performance", "logout"],
    REPORTS:        ["dashboard", "reports", "logout"],
    SYSTEM:         ["admin", "features", "logout"],
    REPRESENTATIVE: ["performance", "logout"],
    MANUFACTURER:   ["reports", "logout"],
  };
  const allowed = ROLE_SECTIONS[auth?.type] ?? ROLE_SECTIONS["ADMIN"];
  const menuItems = topMenu.filter((m) => !m.href || allowed.includes(m.href));

  // Nav only hides disallowed sections; this guard stops direct/stale navigation into one
  // (e.g. a manufacturer session landing on /markit/admin/products from a cached URL).
  const currentSection = location.pathname.split("/")[2];
  if (currentSection && !allowed.includes(currentSection)) {
    const fallback = allowed.find((href) => href !== "logout") ?? "dashboard";
    return <Navigate to={`/markit/${fallback}`} replace />;
  }

  return (
    <main
      className="d-flex flex-nowrap"
      style={{ flexDirection: "column", height: "100vh" }}
    >
      <TopBanner items={menuItems} />
      {readOnly && (
        <div
          className="alert alert-warning mb-0 text-center py-2 fw-semibold"
          style={{ borderRadius: 0, fontSize: "0.9rem" }}
        >
          Read-only mode — changes must be made in the legacy system. Mobile app uploads are still active.
        </div>
      )}
      <div className="d-flex overflow-hidden h-100">
        <Outlet />
      </div>
    </main>
  );
}

export default Root;
